import { IPromotionsData, IPromotion } from "constants/promotion-types";
import { PROMOTION_DESCRIPTION_MAX_LENGTH, PROMOTION_NAME_MAX_LENGTH } from "./consts";

const trimPromotions = <T extends IPromotion>(promoList: T[]): T[] =>
    promoList.map((promo) => ({
        ...promo,
        name: promo.name?.slice(0, PROMOTION_NAME_MAX_LENGTH),
        description: promo.description?.slice(0, PROMOTION_DESCRIPTION_MAX_LENGTH),
    }));

export const applyTrimOnProduct = <T, U>(
    product: T & Map<"promotions", U & { applied: IPromotion[]; threshold: IPromotion[] }>,
): T & Map<"promotions", U & { applied: IPromotion[]; threshold: IPromotion[] }> => {
    const promotions = product?.get("promotions");
    if (!promotions) {
        return product;
    }
    promotions.applied = trimPromotions(promotions.applied);
    promotions.threshold = trimPromotions(promotions.threshold);
    return product.set("promotions", promotions);
};

export const applyTrimOnPromoGroup = <T extends IPromotionsData>(promotions: T): T => {
    if (!promotions) {
        return promotions;
    }

    const { applied = [], threshold = [] } = promotions;
    return {
        ...promotions,
        applied: trimPromotions(applied),
        threshold: trimPromotions(threshold),
    };
};
